import get from 'lodash/get';

import { OrderServiceChoices } from 'entities/OrderService';
import { isInArray, isNullUndEmpty } from './general';

export const upperCaseGetter = (record, source) => {
    const value = get(record, source);
    return value.toUpperCase ? value.toUpperCase() : value;
};

export const rankChoicesGetter = (record) => {
	const choices = record.rank ?
		[{id: record.rank, name: "Auto (" +  record.rank + ")"}, {id: 0, name: "Manual"}] : 
		(record.rank === 0 ? [{id: -1, name: "Auto"}, {id: 0, name: "Manual"}] : [{id: -1, name: "Auto"}, {id: 0, name: "Manual"}]);

	return choices;
};

export const getOrderServiceActiveChoices = (terminal_id, service_id, terminals) => {
	let terminalFilter;

	if (Array.isArray(terminal_id)) {
		if (terminal_id?.length === 0) return OrderServiceChoices;

		const currentTerminalsData = terminals.filter(
			(terminal) => isInArray(terminal_id, terminal.id)
		);

		if (currentTerminalsData.length === 0) return OrderServiceChoices;

		terminalFilter = (service) => (
			currentTerminalsData.every(
				(terminal) =>
					!isInArray(terminal.hidden_service_ids, service.id)
			)
		);
	} else {
		if (isNullUndEmpty(terminal_id)) return OrderServiceChoices;

		const currentTerminalData = terminals.find(
			(terminal) => terminal_id === terminal.id
		);

		if (!currentTerminalData) return OrderServiceChoices;

		terminalFilter = (service) => (
			!isInArray(currentTerminalData.hidden_service_ids, service.id)
		);
	};

	const OrderServiceActiveChoices = OrderServiceChoices.filter(
		(service) => (
			service_id === service.id ||
			terminalFilter(service)
		)
	);

	return OrderServiceActiveChoices;
};
